import { SaveButton } from "components/Buttons"
import ModalComponent from "components/Modals"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import {
  Card,
  CardText,
  CardTitle,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  ListGroup,
  ListGroupItem,
  Row,
  UncontrolledDropdown,
} from "reactstrap"
import {
  checkEventCalendarCanBeDeleted,
  cloneEventCalendar,
  deleteCalendarEvent,
  deleteEventCalendar,
  getAllCalendarEvents,
  getAllEventsCalendar,
  getCalendarEvent,
  getEventCalendarGroup,
  getEventsCalendar,
  hideCloneEventCalendarModal,
  hideDeleteCalendarEventModal,
  hideDeleteEventCalendarModal,
  openCloneEventCalendarModal,
  openDeleteCalendarEventModal,
  openDeleteEventCalendarModal,
} from "store/actions"

const EventCalendarGroupList = ({
  allEventsCalendar,
  allCalendarEvents,
  getAllCalendarEvents,
  handleOpenEventCalendar,
  handleOpenSpecificEvent,
  getEventCalendarGroup,
  checkEventCalendarCanBeDeleted,
  openDeleteEventCalendarModal,
  hideDeleteEventCalendarModal,
  deleteEventCalendar,
  deleteEventCalendarModalIsOpen,
  eventCalendarCanBeDeleted,
  loading,
  getEventsCalendar,
  getAllEventsCalendar,
  cloneEventCalendarModalIsOpen,
  openCloneEventCalendarModal,
  hideCloneEventCalendarModal,
  cloneEventCalendar,
  vendorId,
  deleteCalendarEventModalIsOpen,
  hideDeleteCalendarEventModal,
  openDeleteCalendarEventModal,
  deleteCalendarEvent,
  getCalendarEvent,
}) => {
  const [selectedCalendar, setSelectedCalendar] = useState()
  const [selectedEvent, setSelectedEvent] = useState()

  const calendarActions = [
    {
      name: "Edit",
      onClick: item => {
        getEventCalendarGroup({ id: item?.id })
        handleOpenEventCalendar()
      },
      icon: "bx bx-edit",
      isAvailable: true,
    },
    {
      name: "Clone",
      onClick: item => {
        setSelectedCalendar(item)
        openCloneEventCalendarModal()
      },
      icon: "bx bx-duplicate",
      isAvailable: true,
    },
    {
      name: "Delete",
      onClick: item => {
        setSelectedCalendar(item)
        checkEventCalendarCanBeDeleted({ id: item?.id })
        openDeleteEventCalendarModal()
      },
      icon: "bx bx-trash",
      isAvailable: true,
    },
  ]

  const eventActions = [
    {
      name: "Edit",
      onClick: item => {
        handleOpenSpecificEvent()
      },
      icon: "bx bx-edit",
      isAvailable: true,
    },
    {
      name: "Delete",
      onClick: item => {
        setSelectedEvent(item)
        openDeleteCalendarEventModal()
      },
      icon: "bx bx-trash",
      isAvailable: true,
    },
    {
      name: "Clone",
      onClick: item => {},
      icon: "bx bx-duplicate",
      isAvailable: true,
    },
  ]

  useEffect(() => {
    if (allEventsCalendar?.length > 0) {
      getAllCalendarEvents({
        calendar_ids: allEventsCalendar
          ?.map(calendar => calendar?.id)
          ?.toString(),
      })
    }
  }, [allEventsCalendar])

  return (
    <React.Fragment>
      <Row className="my-3 d-flex justify-content-end">
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Add New Event Calendar Group"
            onClick={handleOpenEventCalendar}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <ListGroup>
            {allEventsCalendar?.map(calendar => (
              <React.Fragment key={calendar?.id}>
                <ListGroupItem
                  className="mt-3"
                  style={{ background: "#F0F0F0" }}
                >
                  <Row>
                    <Col xs="auto" className="mt-1">
                      <div
                        style={{
                          height: "18px",
                          width: "18px",
                          backgroundColor: calendar?.color,
                        }}
                      />
                    </Col>
                    <Col className="mt-1">{calendar?.name}</Col>
                    <Col xs="auto">
                      <SaveButton
                        size="sm"
                        content="Add Event"
                        onClick={handleOpenSpecificEvent}
                      />
                    </Col>
                    <Col xs="auto">
                      <UncontrolledDropdown>
                        <DropdownToggle href="#" className="card-drop" tag="i">
                          <i
                            className="mdi mdi-dots-vertical font-size-18"
                            style={{ cursor: "pointer" }}
                          />
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-end">
                          {calendarActions.map((a, index) => (
                            <DropdownItem
                              key={index}
                              href="#"
                              onClick={e => {
                                e.preventDefault()
                                a.onClick(calendar)
                              }}
                            >
                              <i className={a.icon} /> {a.name}
                            </DropdownItem>
                          ))}
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </Col>
                  </Row>
                </ListGroupItem>
                <Row className="mt-3">
                  {allCalendarEvents
                    ?.filter(event => event?.calendar_id === calendar?.id)
                    ?.map(item => (
                      <Col xs="auto" xl={2} key={item?.id}>
                        <Card
                          body
                          className="py-1 pe-2"
                          style={{ border: "1px solid", minHeight: "100px" }}
                        >
                          <Row className="d-flex justify-content-end">
                            <Col xs="auto">
                              <UncontrolledDropdown>
                                <DropdownToggle
                                  href="#"
                                  className="card-drop"
                                  tag="i"
                                >
                                  <i
                                    className="dripicons-gear font-size-14"
                                    style={{ cursor: "pointer" }}
                                  />
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-end">
                                  {eventActions.map((a, index) => (
                                    <DropdownItem
                                      key={index}
                                      href="#"
                                      onClick={e => {
                                        e.preventDefault()
                                        a.onClick(item)
                                      }}
                                    >
                                      <i className={a.icon} /> {a.name}
                                    </DropdownItem>
                                  ))}
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </Col>
                          </Row>
                          <CardTitle>{item?.name}</CardTitle>
                          <CardText></CardText>
                        </Card>
                      </Col>
                    ))}
                </Row>
              </React.Fragment>
            ))}
          </ListGroup>
        </Col>
      </Row>
      <ModalComponent
        title={`Delete Calendar - "${selectedCalendar?.name}"`}
        open={deleteEventCalendarModalIsOpen}
        onClose={hideDeleteEventCalendarModal}
      >
        {!eventCalendarCanBeDeleted ? (
          <>
            <Row className="mb-2">
              <Col>
                <h5>
                  Cannot delete calendar with active Events. Please delete all
                  Events first.
                </h5>
              </Col>
            </Row>
            <Row className="my-1 d-flex justify-content-end">
              <Col xs="auto">
                <SaveButton
                  type="button"
                  color="danger"
                  content="OK"
                  onClick={hideDeleteEventCalendarModal}
                />
              </Col>
            </Row>
          </>
        ) : (
          <>
            <Row className="mb-2">
              <Col>
                <h5>
                  Deleting calendar also deletes ALL events from this calendar.
                  This cannot be undone.
                </h5>
              </Col>
            </Row>
            <Row className="my-1 d-flex justify-content-end">
              <Col xs="auto">
                <SaveButton
                  type="button"
                  color="danger"
                  content="Cancel"
                  onClick={hideDeleteEventCalendarModal}
                />
              </Col>
              <Col xs="auto">
                <SaveButton
                  type="button"
                  content="Delete"
                  loading={loading}
                  onClick={() => {
                    deleteEventCalendar({
                      id: selectedCalendar?.id,
                      callback: () => {
                        getEventsCalendar({ type: 1 })
                        getAllEventsCalendar({ type: 1 })
                      },
                    })
                  }}
                />
              </Col>
            </Row>
          </>
        )}
      </ModalComponent>
      <ModalComponent
        title={`Clone Calendar - "${selectedCalendar?.name}"`}
        open={cloneEventCalendarModalIsOpen}
        onClose={hideCloneEventCalendarModal}
      >
        <Row className="mb-2">
          <Col>
            <h5>
              Cloning this calendar also clones ALL future calendar events from
              this calendar.
            </h5>
          </Col>
        </Row>
        <Row className="my-1 d-flex justify-content-end">
          <Col xs="auto">
            <SaveButton
              type="button"
              color="danger"
              content="Cancel"
              onClick={hideCloneEventCalendarModal}
            />
          </Col>
          <Col xs="auto">
            <SaveButton
              type="button"
              content="Clone"
              loading={loading}
              onClick={() => {
                cloneEventCalendar({
                  values: {
                    id: selectedCalendar?.id,
                    vendor_id: vendorId,
                  },
                  callback: () => {
                    getEventsCalendar({ type: 1 })
                    getAllEventsCalendar({ type: 1 })
                  },
                })
              }}
            />
          </Col>
        </Row>
      </ModalComponent>
      <ModalComponent
        title={`Delete Event - "${selectedEvent?.name}"`}
        open={deleteCalendarEventModalIsOpen}
        onClose={hideDeleteCalendarEventModal}
      >
        <Row className="mb-2">
          <Col>
            <h5>Are you sure you want to delete this event?</h5>
          </Col>
        </Row>
        <Row className="my-1 d-flex justify-content-end">
          <Col xs="auto">
            <SaveButton
              type="button"
              color="danger"
              content="Cancel"
              onClick={hideDeleteCalendarEventModal}
            />
          </Col>
          <Col xs="auto">
            <SaveButton
              type="button"
              content="Delete"
              loading={loading}
              onClick={() => {
                deleteCalendarEvent({
                  id: selectedEvent?.id,
                  callback: () => {
                    getAllCalendarEvents({
                      calendar_ids: allEventsCalendar
                        ?.map(calendar => calendar?.id)
                        ?.toString(),
                    })
                    getCalendarEvent({
                      calendar_ids: allEventsCalendar
                        ?.map(calendar => calendar?.id)
                        ?.toString(),
                    })
                  },
                })
              }}
            />
          </Col>
        </Row>
      </ModalComponent>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  allEventsCalendar: state.Events.allEventsCalendar,
  allCalendarEvents: state.Events.allCalendarEvents,
  eventCalendarCanBeDeleted: state.Events.eventCalendarCanBeDeleted,
  deleteEventCalendarModalIsOpen: state.Events.deleteEventCalendarModalIsOpen,
  loading: state.Events.loading,
  cloneEventCalendarModalIsOpen: state.Events.cloneEventCalendarModalIsOpen,
  vendorId: state.Login.vendorId,
  deleteCalendarEventModalIsOpen: state.Events.deleteCalendarEventModalIsOpen,
})

const mapDispatchToProps = dispatch => ({
  getAllCalendarEvents: values => dispatch(getAllCalendarEvents(values)),
  getEventCalendarGroup: values => dispatch(getEventCalendarGroup(values)),
  openDeleteEventCalendarModal: () => dispatch(openDeleteEventCalendarModal()),
  checkEventCalendarCanBeDeleted: values =>
    dispatch(checkEventCalendarCanBeDeleted(values)),
  hideDeleteEventCalendarModal: () => dispatch(hideDeleteEventCalendarModal()),
  deleteEventCalendar: values => dispatch(deleteEventCalendar(values)),
  getEventsCalendar: values => dispatch(getEventsCalendar(values)),
  getAllEventsCalendar: values => dispatch(getAllEventsCalendar(values)),
  openCloneEventCalendarModal: () => dispatch(openCloneEventCalendarModal()),
  hideCloneEventCalendarModal: () => dispatch(hideCloneEventCalendarModal()),
  cloneEventCalendar: values => dispatch(cloneEventCalendar(values)),
  openDeleteCalendarEventModal: () => dispatch(openDeleteCalendarEventModal()),
  hideDeleteCalendarEventModal: () => dispatch(hideDeleteCalendarEventModal()),
  deleteCalendarEvent: values => dispatch(deleteCalendarEvent(values)),
  getCalendarEvent: values => dispatch(getCalendarEvent(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EventCalendarGroupList)
